// export const timeSlots = [
//   { value: "10:00 AM - 11:00 AM", label: "10:00 AM - 11:00 AM" },
//   { value: "11:00 AM - 12:00 PM", label: "11:00 AM - 12:00 PM" },
//   { value: "12:00 PM - 1:00 PM", label: "12:00 PM - 1:00 PM" },
//   { value: "1:00 PM - 2:00 PM", label: "1:00 PM - 2:00 PM" },
//   { value: "2:00 PM - 3:00 PM", label: "2:00 PM - 3:00 PM" },
//   { value: "3:00 PM - 4:00 PM", label: "3:00 PM - 4:00 PM" },
//   { value: "4:00 PM - 5:00 PM", label: "4:00 PM - 5:00 PM" },
//   { value: "5:00 PM - 6:00 PM", label: "5:00 PM - 6:00 PM" },
// ];

export const timeSlots = [
  { value: "08:00 AM - 10:00 AM", label: "08:00 AM - 10:00 AM" },
  { value: "01:00 PM - 03:00 PM", label: "01:00 PM - 03:00 PM" },
  { value: "06:00 PM - 08:30 PM", label: "06:00 PM - 08:30 PM" },
];

// placeOrderConst.js
export const serviceSelectSteps = [
  { label: "Pickup Details", route: "pickup-details" },
  { label: "Clothes", route: "add-to-cart" },
  { label: "Shop", route: "shop-selection" },
  { label: "Order Review", route: "review-place-order" },
];

export const shopSelectSteps = [
  // { label: "Shop", route: "shop-selection" },
  // { label: "Select Service", route: "select-service" },
  { label: "Pickup Details", route: "pickup-details" },
  { label: "Clothes", route: "add-to-cart" },
  { label: "Order Review", route: "review-place-order" },
];
